import { useState, useEffect } from 'react';

import Alert from '@mui/material/Alert';
import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { customInstanceApis } from '../../../apis/customInstanceApis';
import Loading from '../../../components/elements/loading/Loading';
import Breadcrumbs from '../../../components/sections/breadcrumbs/Breadcrumbs';
import InstanceInfo from '../../../components/sections/overview/InstanceInfo';
import Overview from '../../../components/sections/overview/Overview';

const CustInstOverviewPage = () => {
  const { projectId, customInstId } = useParams();
  const { t } = useTranslation();

  const [instance, setInstance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data: instanceRes } = await customInstanceApis.getCustomInstance(
        projectId,
        customInstId
      );

      setInstance(instanceRes);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) return <Loading />;

  if (error)
    return (
      <Alert style={{ marginTop: '1em' }} severity="error">
        {t('fetchCustomInstError', { ns: 'notifications' })}
      </Alert>
    );

  return (
    <Container>
      <Breadcrumbs customInstName={instance.name} />
      <Overview data={instance} />
      <InstanceInfo instance={instance} />
    </Container>
  );
};

export default CustInstOverviewPage;
